import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5be411a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Here's an example:", -1))
const _hoisted_2 = { class: "bg-gray-200 mt-5 copy-father" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "nes-btn is-primary copy",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doCopyJSON(_ctx.data)))
      }, _toDisplayString(_ctx.copyText), 1),
      _createVNode(_component_vue_json_pretty, {
        class: "text-xs",
        data: _ctx.data
      }, null, 8, ["data"])
    ])
  ]))
}